export default "__VITE_ASSET__0c568338__"